import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Divider,
} from "@mui/material";

import SettingsIcon from "@mui/icons-material/Settings";
import CloudIcon from "@mui/icons-material/Cloud";
import DeviceThermostatIcon from "@mui/icons-material/DeviceThermostat";
import OpacityIcon from "@mui/icons-material/Opacity";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

export default function Tab1TempTab() {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 3,
        p: 1,
        backgroundColor: "#f8f9fa",
        height:"400px"
      }}
    >
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={2}
        py={1}
      >
        <Typography fontWeight="bold">Current Weather</Typography>
        <IconButton size="small">
          <SettingsIcon />
        </IconButton>
      </Box>

      <Divider />

      <CardContent>
        {/* Weather Type */}
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <CloudIcon color="success" />
          <Typography>Current Weather</Typography>

          <Typography sx={{ mx: 1 }}>🌫️</Typography>
          <Typography>haze</Typography>
        </Box>

        {/* Temperature */}
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <DeviceThermostatIcon color="info" />
          <Typography>Temperature : 34°C</Typography>
        </Box>

        {/* Humidity */}
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <OpacityIcon color="primary" />
          <Typography>Humidity : 59</Typography>
        </Box>

        {/* Irradiation */}
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <WbSunnyIcon color="warning" />
          <Typography>Irradiation : 266.0 W/m²</Typography>
        </Box>

        {/* Date Time */}
        <Box display="flex" alignItems="center" gap={1} mt={2}>
          <CalendarTodayIcon color="success" />
          <Typography fontSize="14px">
            17:17 Tuesday, April 14, 2026
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}